import { RoastPoint } from "../input/roastingSeriesTypes";

/**
 * 기준 BT 이상 구간에서의 누적 열 노출량 적분
 * (질량 손실의 1차 설명 변수)
 */
export function calcThermalExposure(
  series: RoastPoint[],
  startTime: number,
  endTime: number,
  baseBT: number
): { exposure: number; max: number } {
  let exposure = 0;
  let max = 0;

  for (let i = 1; i < series.length; i++) {
    const prev = series[i - 1];
    const curr = series[i];

    // 건조 이후 ~ 배출 구간만 사용
    if (curr.time < startTime || prev.time > endTime) continue;

    const dt = curr.time - prev.time;
    if (dt <= 0) continue;

    const dBT = curr.bt - prev.bt;
    const ror = dBT / dt; // °C / s
    if (max < curr.bt) max = curr.bt;

    // 하강 또는 정체 구간 제외 (핵심 보정)
    // if (ror <= 0) continue;

    //const btAvg = ror <= 0 || curr.bt < max ? max - baseBT : (prev.bt + curr.bt) / 2 - baseBT;
    const btAvg = (prev.bt + curr.bt) / 2 / (ror <= 0 ? 10 : 1);

    // 기준선 초과 + 실제 가열 구간만 적분
    if (btAvg > 0) {
      exposure += btAvg * dt;
    }
  }

  return { exposure, max };
}
